var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../atoms/BaseButton';
import styled from 'styled-components';
import Dialog from '../../atoms/Dialog';
import { useNavigate } from 'react-router-dom';
import { Typography, Divider } from '@mui/material';
import TextField from '../../atoms/TextField';
import SelectBankAccountList from './SelectBankAccountList';
var ExplanationText = styled(Typography).attrs({ variant: 'caption' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: pre-line;\n  word-break: break-word;\n"], ["\n  white-space: pre-line;\n  word-break: break-word;\n"])));
var AddBankAccountButtonWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 20px 20px;\n  text-align: center;\n"], ["\n  margin: 20px 20px;\n  text-align: center;\n"])));
var StyledTextField = styled(TextField)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 20px 0px;\n"], ["\n  margin: 20px 0px;\n"])));
var SelectBankAccountDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, producer = _a.producer, onSubmit = _a.onSubmit, loading = _a.loading;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var _b = React.useState(), bankAccountId = _b[0], setBankAccountId = _b[1];
    var _c = React.useState(), messages = _c[0], setMessages = _c[1];
    var producerHasBankAccount = React.useMemo(function () { return producer.bankAccounts.length !== 0; }, [producer.bankAccounts.length]);
    var handleConfirm = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            if (!bankAccountId)
                return [2 /*return*/];
            data = {
                producer_bank_account_id: bankAccountId,
                producer_messages: messages,
            };
            onSubmit(data);
            return [2 /*return*/];
        });
    }); }, [bankAccountId, messages, onSubmit]);
    return producerHasBankAccount ? (React.createElement(Dialog, { title: t('messages.salesContractDownloadExplanationTitle'), open: open, onClose: onClose, actions: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: handleConfirm, color: "primary", disabled: loading || !bankAccountId }, t('buttons.addItem')),
            React.createElement(Button, { onClick: onClose }, t('buttons.no'))) },
        React.createElement(ExplanationText, null, t('messages.salesContractDownloadExplanationBody')),
        React.createElement(SelectBankAccountList, { selectedBankAccountId: bankAccountId, onChange: function (value) { return setBankAccountId(value); }, bankAccounts: producer.bankAccounts }),
        React.createElement(Divider, null),
        React.createElement(StyledTextField, { label: t('params.salesContract.producerMessages'), name: "producer_messages", fullWidth: true, multiline: true, rows: 4, onChange: function (e) { return setMessages(e.target.value); } }))) : (React.createElement(Dialog, { title: t('messages.salesContractDownloadExplanationTitle'), open: open, onClose: onClose, actions: React.createElement(React.Fragment, null) },
        React.createElement(ExplanationText, null, t('messages.addBankAccountInformation')),
        React.createElement(AddBankAccountButtonWrapper, null,
            React.createElement(Button, { onClick: function () { return navigate("/producer/bank_accounts/new"); }, color: "primary" }, t('buttons.setBankAccount')))));
};
export default SelectBankAccountDialog;
var templateObject_1, templateObject_2, templateObject_3;
